import { Context, useContext } from 'react';

import {
  ImageEntity,
  TextSubtext,
  CityServices,
  CityService,
  FareEstimateContent,
} from '../../shared/cities/domain/entities/CitiesEntity';

import { context as mjsModalContext } from './ModalContext.mjs';

export interface ModalVariant {
  TAG: number;
  _0: unknown;
  _1?: unknown;
  _2?: unknown;
  _3?: unknown;
  _4?: unknown;
  _5?: unknown;
}

export interface ModalContextType {
  modal: ModalVariant | undefined;
  toggleModal: (modal: ModalVariant | undefined) => void;
}

const context = mjsModalContext as Context<ModalContextType>;

export function useModalContext(): ModalContextType {
  return useContext(context);
}

export { context as ModalContextRaw };

export function openCitySelectorModal(
  cityData: CityServices[],
  closeIcon: ImageEntity,
  cityTitleDesc: TextSubtext,
): ModalVariant {
  return { TAG: 7, _0: true, _1: cityData, _2: closeIcon, _3: cityTitleDesc };
}

export function openFareEstimateModal(
  categoryCards: CityService[],
  fareEstimateFormContent: unknown,
  modalContent: FareEstimateContent,
): ModalVariant {
  return {
    TAG: 9,
    _0: true,
    _1: categoryCards,
    _2: fareEstimateFormContent,
    _3: modalContent,
  };
}

export function openPaymentSuccessModal(): ModalVariant {
  return { TAG: 17, _0: true, _1: 0, _2: 0 };
}

export function openPaymentFailureModal(amount: string): ModalVariant {
  return { TAG: 17, _0: true, _1: { TAG: 0, _0: amount }, _2: 0 };
}
